import {TypedStorage} from './types';

export function getStorage(): TypedStorage {
  return {
    setItem(key, value) {
      try {
        if (value === null) {
          localStorage.removeItem(key);
        } else {
          localStorage.setItem(key, JSON.stringify(value));
        }
      } catch {
        // Ignore if storage restriction error
      }
    },
    getItem(key) {
      try {
        const storedValue = localStorage.getItem(key);
        if (storedValue) {
          return JSON.parse(storedValue);
        }
      } catch {
        // Ignore if storage restriction or parsing error
      }
      return null;
    },
  };
}

export function isMobileDevice() {
  return [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ].some((toMatchItem) => navigator.userAgent.match(toMatchItem));
}
